import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import DashboardPage from '@/pages/DashboardPage';
import SessionsPage from '@/pages/SessionsPage';
import SessionDetailPage from '@/pages/SessionDetailPage';
import MoodPage from '@/pages/MoodPage';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import ManageSessions from '@/pages/admin/ManageSessions';
import ManageAdmins from '@/pages/admin/ManageAdmins';
import ManageUsers from '@/pages/admin/ManageUsers';
import ManageDomains from '@/pages/admin/ManageDomains';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/sessions/:sessionId" element={<SessionDetailPage />} />
          <Route path="/mood" element={<MoodPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/sessions" element={<ManageSessions />} />
          <Route path="/admin/manage-admins" element={<ManageAdmins />} />
          <Route path="/admin/users" element={<ManageUsers />} />
          <Route path="/admin/domains" element={<ManageDomains />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
